export const addDiagnose = (item: any) => ({
    type: "ADD_DIAGNOSE",
    payload: item,
  });
export const addDiagnoseNote = (item: any) => ({
    type: "ADD_DIAGNOSE_NOTE",
    payload: item,
  });
export const addAditionalNote = (item: any) => ({
    type: "ADD_ADITIONAL_NOTE",
    payload: item,
  });
export const removeDiagnose = (item: any) => ({
    type: "REMOVE_DIAGNOSE",
    payload: item,
  });
export const addDiagnoses = (item: any) => ({
    type: "ADD_DIAGNOSES",
    payload: item,
  });
export const addDiagnosesImage = (item: any) => ({
    type: "ADD_DIAGNOSES_IMAGE",
    payload: item,
  });
export const addTreatmentImage = (item: any) => ({
    type: "ADD_TREATMENT_IMAGE",
    payload: item,
  });
  export const addPatientComplain = (item: any) => ({
    type: "ADD_COMPLAIN",
    payload: item,
  });
  export const addPatientComplains = (item: any) => ({
    type: "ADD_COMPLAINS",
    payload: item,
  });
  export const removeComplain = (item: any) => ({
    type: "REMOVE_COMPLAIN",
    payload: item,
  });
  export const addInvestigations = (item: any) => ({
    type: "ADD_INVESTIGATIONS",
    payload: item,
  });
  export const addInvestigation = (item: any) => ({
    type: "ADD_INVESTIGATION",
    payload: item,
  });


  export const addPrescriptions = (item: any) => ({
    type: "ADD_PRESCRIPTIONS",
    payload: item,
  });
  export const addPrescription = (item: any) => ({
    type: "ADD_PRESCRIPTION",
    payload: item,
  });
  export const removePrescription = (item: any) => ({
    type: "REMOVE_PRESCRIPTION",
    payload: item,
  });

  export const addInvestigationImage = (id: any,images:any) => ({
    type: "ADD_INVESTIGATION_IMAGES",
    payload: {id,images},
  });
  export const removeInvestigationImage = (invid: any,imageid:any) => ({
    type: "REMOVE_INVESTIGATION_IMAGES",
    payload: {invid,imageid},
  });
  export const removeInvestigation = (item: any) => ({
    type: "REMOVE_INVESTIGATION",
    payload: item,
  });
  export const makeAction = () => ({
    type: "MAKE_ACTION",
  });